<div
    class="tw-flex tw-justify-evenly sm:tw-p-6 tw-h-[100vh] tw-gap-5 sm:tw-bg-[#0A0A75] tw-bg-transparent tw-items-start sm:tw-items-center"
>
    <div
        class="tw-w-full sm:tw-w-[80%] lg:tw-w-[60%] tw-pt-4 tw-pb-10 xl:tw-w-[36%] tw-bg-white tw-rounded-[24px] tw-flex tw-flex-col tw-relative tw-z-[2]"
    >
        <header class="tw-text-center">
            <div
                class="tw-flex tw-justify-between tw-items-center tw-min-h-[4rem] tw-px-8 md:tw-px-10"
            >
                <div class="tw-flex-1"></div>
                <img
                    src="/assets/images/logo/header_desktop.webp"
                    alt="IMSME Logo"
                    class="tw-cursor-pointer tw-h-auto tw-w-[35%] tw-mx-auto"
                    [routerLink]="['/home']"
                />
                <div
                    class="tw-text-[16px] tw-font-medium tw-flex-1 tw-text-right"
                >
                    <span
                        class="tw-cursor-pointer"
                        (click)="switchLanguage('en')"
                        >{{ "LANG.EN" | translate }}</span
                    >
                    |
                    <span
                        class="tw-cursor-pointer"
                        (click)="switchLanguage('bm')"
                        >{{ "LANG.BM" | translate }}</span
                    >
                </div>
            </div>
        </header>
        <div class="tw-px-8 md:tw-px-16 tw-mt-2">
            <div
                class="tw-text-[24px] md:tw-text-[28px] tw-font-semibold tw-w-full"
            >
                {{ "RESET_PASSWORD.RESET_PASSWORD_TITLE" | translate }}
            </div>
            <div
                class="d-none tw-text-gray-400 tw-flex tw-text-center tw-justify-center tw-mt-3"
            >
                {{ userName }}
            </div>
        </div>
        <div
            class="tw-px-8 md:tw-px-16 tw-mt-4 tw-flex-1 tw-min-h-0 tw-flex tw-flex-col"
        >
            <form
                [formGroup]="resetPasswordForm"
                (ngSubmit)="onResetPassword()"
                class="tw-h-full tw-flex tw-flex-col tw-relative tw-max-h-none sm:tw-max-h-[550px] xl:tw-max-h-[385px]"
            >
                <div
                    class="tw-flex-1 tw-overflow-y-auto custom-scroll"
                    style="scrollbar-width: thin"
                >
                    <div class="tw-w-full">
                        <input-general
                            class="tw-block tw-w-[100%] tw-rounded-2xl"
                            [mandatoryField]="true"
                            [label]="'COMMON.CONFIRMATION_CODE' | translate"
                            [placeHolder]="'**********'"
                            [hideInput]="true"
                            [controlName]="'confirmationCode'"
                            [errors]="
                                getErrors(
                                    'confirmationCode',
                                    'COMMON.CONFIRMATION_CODE' | translate
                                )
                            "
                        ></input-general>
                        <input-general
                            class="tw-block tw-mt-5 tw-w-[100%] tw-rounded-2xl"
                            [mandatoryField]="true"
                            [label]="'PROFILE.NEW_PASSWORD' | translate"
                            [placeHolder]="'**********'"
                            [hideInput]="true"
                            [strength]="pswdStrength"
                            [strengthLabel]="pswdStrengthLabel"
                            [strengthColor]="pswdStrengthColor"
                            [controlName]="'password'"
                            [errors]="
                                getErrors(
                                    'password',
                                    'PROFILE.NEW_PASSWORD' | translate
                                )
                            "
                            (keyup)="checkPasswordStatus($event)"
                        ></input-general>
                        <input-general
                            class="tw-block tw-mt-5 tw-w-[100%] tw-rounded-2xl"
                            [mandatoryField]="true"
                            [label]="'FORM.CONFIRM_PASSWORD' | translate"
                            [placeHolder]="'**********'"
                            [hideInput]="true"
                            [controlName]="'confirmPassword'"
                            [errors]="
                                getErrors(
                                    'confirmPassword',
                                    'FORM.CONFIRM_PASSWORD' | translate
                                )
                            "
                            (paste)="disablePaste($event)"
                        ></input-general>
                        <!-- Add padding bottom to account for sticky content -->
                        <div class="tw-h-[80px]"></div>
                    </div>
                </div>
                <div
                    class="tw-mt-4 tw-flex tw-flex-col tw-gap-4 tw-bg-white tw-absolute tw-bottom-0 tw-left-0 tw-right-0"
                >
                    <button
                        class="tw-rounded-[32px] tw-text-white tw-font-bold tw-h-[56px] tw-w-full tw-text-[16px]"
                        type="submit"
                        [ngClass]="
                            resetPasswordForm.invalid
                                ? 'tw-bg-[#FFA53C] tw-opacity-50'
                                : 'tw-bg-[#FFA53C]'
                        "
                    >
                        {{ "RESET_PASSWORD.RESET" | translate }}
                    </button>
                </div>
            </form>
        </div>
    </div>
    <img
        class="tw-hidden sm:tw-block tw-absolute tw-left-0 tw-bottom-0"
        src="../../../../assets/images/login-signup/Blue-1.png"
        alt="Blue Img"
    />
</div>
